<template>
  <footer class="app-footer">
    &copy; 2017 <a href="https://part.domaine-de-limagne.com">Domaine de Limagne</a>.
  </footer>
</template>
<script>
export default {
  name: 'footer'
}
</script>



// WEBPACK FOOTER //
// Footer.vue?044a779a